// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Offline indicator (top bar), pending-changes sheet, editor banner and row tag */

.offline-indicator.ant-btn.offline-indicator--offline {
  color: var(--ds-warning) !important;
  background: var(--ds-warning-bg) !important;
}

.offline-sheet .ant-drawer-content-wrapper {
  max-height: 85vh;
}

.offline-sheet .ant-drawer-footer {
  padding-block-end: calc(var(--ds-space-3) + var(--ds-safe-bottom, 0px));
}

.offline-sheet__status {
  display: grid;
  gap: var(--ds-space-2);
  margin-block-end: var(--ds-space-4);
}

.offline-sheet__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: var(--ds-space-3);
}

.offline-sheet__item {
  padding: var(--ds-space-3);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-md);
  background: var(--ds-surface);
}

.offline-sheet__item-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--ds-space-2);
  margin-block-end: var(--ds-space-2);
}

.offline-sheet__item-title {
  display: grid;
  min-width: 0;
  overflow-wrap: anywhere;
}

.offline-sheet__item-sub {
  color: var(--ds-text-muted);
  font-size: 13px;
}

.offline-sheet__error.ant-typography {
  margin-block-end: var(--ds-space-2);
  font-size: 13px;
  overflow-wrap: anywhere;
}

.offline-notice.ant-alert {
  margin-block-end: var(--ds-space-3);
}

.offline-tag.ant-tag {
  margin-inline-start: var(--ds-space-1);
}
`, "",{"version":3,"sources":["webpack://./src/offline/offline.css"],"names":[],"mappings":"AAAA,kFAAkF;;AAElF;EACE,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,uCAAuC;EACvC,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;AACxC","sourcesContent":["/* Offline indicator (top bar), pending-changes sheet, editor banner and row tag */\n\n.offline-indicator.ant-btn.offline-indicator--offline {\n  color: var(--ds-warning) !important;\n  background: var(--ds-warning-bg) !important;\n}\n\n.offline-sheet .ant-drawer-content-wrapper {\n  max-height: 85vh;\n}\n\n.offline-sheet .ant-drawer-footer {\n  padding-block-end: calc(var(--ds-space-3) + var(--ds-safe-bottom, 0px));\n}\n\n.offline-sheet__status {\n  display: grid;\n  gap: var(--ds-space-2);\n  margin-block-end: var(--ds-space-4);\n}\n\n.offline-sheet__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: var(--ds-space-3);\n}\n\n.offline-sheet__item {\n  padding: var(--ds-space-3);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-md);\n  background: var(--ds-surface);\n}\n\n.offline-sheet__item-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: var(--ds-space-2);\n  margin-block-end: var(--ds-space-2);\n}\n\n.offline-sheet__item-title {\n  display: grid;\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.offline-sheet__item-sub {\n  color: var(--ds-text-muted);\n  font-size: 13px;\n}\n\n.offline-sheet__error.ant-typography {\n  margin-block-end: var(--ds-space-2);\n  font-size: 13px;\n  overflow-wrap: anywhere;\n}\n\n.offline-notice.ant-alert {\n  margin-block-end: var(--ds-space-3);\n}\n\n.offline-tag.ant-tag {\n  margin-inline-start: var(--ds-space-1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
